import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth-context";
import { useT } from "../i18n/index";
import { OidcAuth } from "./oidc";

// The anonymous landing — a single explicit "sign in" action (suggest-not-decide
// extends to auth: nothing happens without the advisor's click).
export function LoginScreen() {
  const { login } = useAuth();
  const { t } = useT();
  return (
    <main className="center">
      <h1>{t("app.title")}</h1>
      <p className="muted">{t("auth.signin_prompt")}</p>
      <button type="button" onClick={() => void login()}>
        {t("auth.login")}
      </button>
    </main>
  );
}

// The PKCE authorization code is SINGLE-USE. React StrictMode double-invokes effects
// in dev, which would run the exchange twice and 400 the second call (code already
// redeemed). Module-scoped guard → completeLogin runs exactly once per redirect.
let callbackStarted = false;

// The OIDC redirect target: completes the PKCE exchange, then returns home.
export function CallbackScreen({ auth }: { auth: OidcAuth }) {
  const navigate = useNavigate();
  const { t } = useT();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (callbackStarted) return;
    callbackStarted = true;
    void auth
      .completeLogin()
      .then(() => navigate("/", { replace: true }))
      .catch(() => setFailed(true));
  }, [auth, navigate]);
  return <main className="center">{failed ? t("error.generic") : t("auth.loading")}</main>;
}
